export default __webpack_public_path__ + "static/media/kitchen5-afterE-1024w.35e5b33d.avif";